import { memo, useCallback } from 'react'
import { Tabs } from 'components'
import { useTranslation } from 'react-i18next'
import { useBrowseTree } from './context/BrowseTreeContext'
import { BrowseTab } from './types'

export const BrowseTreeTabs = memo(() => {
  const { t } = useTranslation()
  const { activeTab, setActiveTab, isDataReady } = useBrowseTree()

  const handleTabChange = useCallback((value: string | null) => {
    if (value === 'standards' || value === 'skills') {
      setActiveTab(value as BrowseTab)
    }
  }, [setActiveTab])

  return (
    <Tabs
      value={activeTab}
      onTabChange={handleTabChange}
      styles={theme => ({
        tab: {
          fontWeight: 600,
          fontSize: 15,
          padding: '12px 0',
          marginRight: 24,
          color: theme.colorScheme === 'dark'
            ? theme.colors.gray[5]
            : theme.colors.gray[6],
          borderBottom: '2px solid transparent',
          marginBottom: -1,
          transition: 'color 0.15s ease, border-color 0.15s ease',
          '&:hover': {
            backgroundColor: 'transparent',
            color: theme.colorScheme === 'dark'
              ? theme.colors.gray[3]
              : theme.colors.gray[7],
          },
          '&[data-active]': {
            color: theme.colorScheme === 'dark'
              ? theme.white
              : theme.black,
            borderBottomColor: theme.colors.teal[5],
            backgroundColor: 'transparent',
          },
        },
        tabsList: {
          borderBottom: `1px solid ${
            theme.colorScheme === 'dark'
              ? theme.colors.dark[4]
              : theme.colors.gray[2]
          }`,
          gap: 0,
        },
      })}
    >
      <Tabs.List>
        <Tabs.Tab value="standards" disabled={!isDataReady}>
          {t('arc_browse_tab_standards')}
        </Tabs.Tab>
        <Tabs.Tab value="skills" disabled={!isDataReady}>
          {t('arc_browse_tab_skills')}
        </Tabs.Tab>
      </Tabs.List>
    </Tabs>
  )
})

BrowseTreeTabs.displayName = 'BrowseTreeTabs'
